/* External Imports */
import { Box, Grid, Image, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';

/**
 * Render Benefits Section Component
 * @description Renders the BenefitsSection component
 * @param {Array} benefitsData - Data 
 * @returns {ReactElement} Benefits Section component
 */
const BenefitsSection = ({ benefitsData }) => {
  return (
    <Box
      bgColor="#FFF7E2"
      pb={{ base: '0', md: '60px' }}
      position="relative"
      mt={{ base: '-1px', md: '0' }}
      _before={{
        bgImage: `url('${config.staticPath}/d/46272/1642670504-bg_kolam2.png')`,
        // bgImage: `url('https://images.sadhguru.org/d/46272/1642670504-bg_kolam2.png')`,
        display: { base: 'none', md: 'block' },
        content: '""',
        height: '400px',
        width: '340px',
        pos: 'absolute',
        right: '0',
        top: '-90px',
        backgroundSize: '90%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right center',
        zIndex: '1',
      }}
    >
      <Text
        as="h1"
        fontSize={{ base: '27px', md: '40px' }}
        fontFamily="FedraSansStd-A-medium"
        textAlign="center"
        lineHeight="43px"
        px={{ base: '20px', md: '0' }}
        pb="20px"
        maxW="450px"
        mx="auto"
        zIndex="2"
        position="relative"
      >
        {benefitsData.title[0].titleText}
      </Text>
      <Box textAlign="center" mb="30px">
        <Image
          loading="lazy"
          src={`${config.staticPath}/d/46272/1656740172-yantra_sectiontitle_flower.png`}
          // src={`https://images.sadhguru.org/d/46272/1656740172-yantra_sectiontitle_flower.png`}
          m="20px auto"
        />
      </Box>
      <Box
        maxWidth={{ base: '990px' }}
        mx="auto"
        padding={{ base: '0 20px', md: '0 40px' }}
      >
        <Grid
          templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
        >
          {benefitsData.benefits.map((data, i) => {
            return (
              <Box textAlign="center" mb="50px" key={i}>
                <Image
                  loading="lazy"
                  src={data?.image?.url}
                  alt={data?.image?.alt}
                  title={data?.image?.title}

                  width="250px"
                  height="250px"
                  mb={{ base: '20px', md: '25px' }}
                  borderRadius="50%"
                  minH="250px"
                />
                <Text
                  fontSize={{ base: '18px', md: '22px' }}
                  fontFamily="FedraSansStd-medium"
                  maxW={{ base: '290px', md: '380px' }}
                  mx="auto"
                  color="#28231E"
                >
                  {data.text}
                </Text>
              </Box>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default BenefitsSection;
